// Core
import React from "react";
import { Pie } from "react-chartjs-2";
import "chart.js/auto";

// Styles
import "./styles.scss";

// Assets
import Emoji_AverageSmile from "../../Assets/Svg/Auth/Emoji_AverageSmile.svg";
import Emoji_BlankFace from "../../Assets/Svg/Auth/Emoji_BlankFace.svg";
import Emoji_BrightSmile from "../../Assets/Svg/Auth/Emoji_BrightSmile.svg";
import Emoji_SadSmile from "../../Assets/Svg/Auth/Emoji_SadSmile.svg";

function PieChart({ headingName, performanceRating, color }) {
  // Assuming performanceRating is out of 5, otherwise adjust the logic
  const data = {
    labels: ["Performance Rating", "Remaining"],
    datasets: [
      {
        // Dataset label
        data: [performanceRating, 100 - performanceRating],
        backgroundColor: [color, "#ecf0f1"],
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    layout: {
      padding: 10,
    },
  };
  const getEmoji = (rating) => {
    if (rating >= 50) {
      return Emoji_BrightSmile;
    } else {
      return Emoji_BlankFace;
        // return Emoji_AverageSmile;
        // return Emoji_SadSmile;
    } 
    // else if (rating >= 20) {
      // } else {
    // }
  };
  return (
    <div className="pie-chart-container">
      <div className="pie-chart-heading">
        <h3 className="pie-chart-heading-top">{headingName}</h3>{" "}
        {/* Heading of the chart */}
      </div>
      <div className="chart-wrapper">
        <Pie
          data={data}
          options={options}
          style={{ width: "150px", height: "150px" }}
        />
      </div>
      {/* ternary operator need to implement for emoji checking */}
      <h4 className="piechart-rating">
        <span>
          <img
            src={getEmoji(performanceRating)}
            alt=""
            width={24}
            height={24}
            style={{ marginBottom: "1px" }}
          />
        </span>{" "}
        <span style={{ color: "#00B69B" }}>{performanceRating}%</span> vs
        Industry peers
      </h4>{" "}
      {/* Performance rating */}
    </div>
  );
}

export default PieChart;
